import styled from 'styled-components';

const OptionsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(101px, 1fr));
  grid-auto-rows: 80px;
  grid-gap: ${({ theme }) => theme.spacing.S8};
  margin-bottom: ${({ theme }) => theme.spacing.S4};
`;

export { OptionsList };
